import { render, staticRenderFns } from "./CalendarEventHandler.vue?vue&type=template&id=07637fb7&"
import script from "./CalendarEventHandler.vue?vue&type=script&lang=js&"
export * from "./CalendarEventHandler.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventHandler.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07637fb7')) {
      api.createRecord('07637fb7', component.options)
    } else {
      api.reload('07637fb7', component.options)
    }
    module.hot.accept("./CalendarEventHandler.vue?vue&type=template&id=07637fb7&", function () {
      api.rerender('07637fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/calendar/calendar-event-handler/CalendarEventHandler.vue"
export default component.exports